import { Reveal, Bubbles } from "@/components/site/Motion";
import { Btn } from "@/components/site/Btn";
import { FileText, ArrowUpRight } from "lucide-react";
import { RESOURCES } from "@/lib/content";
import { WHITE_PAPERS } from "@/lib/assets";

export default function Resources() {
  return (
    <>
      <section className="relative bg-gradient-to-b from-yellow/30 to-cream pt-16 md:pt-24 pb-12 overflow-hidden" data-testid="resources-hero">
        <Bubbles count={7} />
        <div className="max-w-5xl mx-auto px-6 md:px-10 relative">
          <Reveal>
            <p className="font-body text-sm font-bold uppercase tracking-[0.15em] text-ocean mb-4">Resources</p>
            <h1 className="font-display font-extrabold text-5xl md:text-7xl text-navy leading-[0.95]">{RESOURCES.hero}</h1>
            <p className="font-body text-lg md:text-xl text-navy/70 mt-6 max-w-2xl">{RESOURCES.heroSub}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-8" data-testid="resources-building">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal><h2 className="font-display font-bold text-3xl md:text-4xl text-navy">{RESOURCES.building.title}</h2></Reveal>
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-8">
            {RESOURCES.building.cards.map((c, i) => (
              <Reveal key={c.key} delay={i * 0.1}>
                <div className={`h-full ${i === 0 ? "bg-sky/15 border-sky" : "bg-coral/15 border-coral"} border-2 rounded-3xl p-8 shadow-brutal flex flex-col`} data-testid={`resource-${c.key}`}>
                  <span className="w-14 h-14 grid place-items-center rounded-2xl bg-white border-2 border-navy"><FileText className="w-7 h-7" /></span>
                  <h3 className="font-display font-extrabold text-2xl text-navy mt-5">{c.name}</h3>
                  <p className="font-body text-navy/75 mt-3 flex-1">{c.desc}</p>
                  <div className="mt-6"><Btn href={WHITE_PAPERS[c.key]} variant="white" testid={`resource-cta-${c.key}`}>{c.cta} <ArrowUpRight className="w-5 h-5" /></Btn></div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24" data-testid="resources-migration">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal><h2 className="font-display font-bold text-3xl md:text-4xl text-navy">{RESOURCES.migration.title}</h2></Reveal>
          <Reveal delay={0.1}>
            <div className="bg-navy border-2 border-navy rounded-3xl p-8 md:p-12 mt-8 grid md:grid-cols-[1fr_auto] gap-8 items-center shadow-brutal">
              <div>
                <span className="w-14 h-14 grid place-items-center rounded-2xl bg-yellow border-2 border-cream"><FileText className="w-7 h-7 text-navy" /></span>
                <h3 className="font-display font-extrabold text-3xl md:text-4xl text-cream mt-5">{RESOURCES.migration.card.name}</h3>
                <p className="font-body text-yellow font-bold mt-2">{RESOURCES.migration.card.subtitle}</p>
                <p className="font-body text-cream/80 mt-4 max-w-xl">{RESOURCES.migration.card.desc}</p>
              </div>
              <Btn href={WHITE_PAPERS.platform} variant="yellow" testid="resource-cta-platform" className="whitespace-nowrap">{RESOURCES.migration.card.cta} <ArrowUpRight className="w-5 h-5" /></Btn>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
